<div class="common-date__counter w-[59px]"
  [ngClass]="{ 'common-date__counter--disabled': disabled}">
  <p-inputNumber class="common-text-input__container-input"
    styleClass="common-text-input__input-number"
    [inputId]="'input-number-value-' + id"
    mode="decimal"
    [min]="inputNumber.from"
    [maxlength]="inputNumber.until"
    [useGrouping]="false"
    [disabled]="disabled"
    [(ngModel)]="inputNumber.value"
    (onBlur)="changeNumber()">
  </p-inputNumber>
  <div class="common-date__counter-buttons">
    <i class="lf-icon-angle-up common-icon__sm-clickable"
      [ngClass]="{'common-icon__sm-clickable--disabled': inputNumber.value === inputNumber.until || disabled}"
      (click)="addOrRemoveAmount('add')"></i>
    <i class="lf-icon-angle-down common-icon__sm-clickable"
      [ngClass]="{'common-icon__sm-clickable--disabled': inputNumber.value === inputNumber.from || disabled}"
      (click)="addOrRemoveAmount('remove')"></i>
  </div>
</div>
